import { InsightPanel, hasEventInsights, useFilters, useTeamEvents } from '@statsbomb/kitbag-global-football';
import { useAtomValue } from 'jotai';
import { unwrappedTeamGamesAtom } from '@/atoms/queries/teams';
import { teamIdAtom } from '@/atoms/team/team';
import { EventInsightsCard } from '@/components/visualisations/EventInsightsCard';
import { EventInsightsEmpty } from '@/components/visualisations/EventInsightsEmpty';
import { useIsNarrowViewport } from '@/hooks/useIsNarrowViewport';
import { getSelectedEventTypes } from '@/utils/filters';

export const TeamEventInsights = () => {
  const isNarrowViewport = useIsNarrowViewport();

  const teamId = useAtomValue(teamIdAtom);
  const games = useAtomValue(unwrappedTeamGamesAtom);
  const [filters] = useFilters('main');

  const selectedEventTypes = getSelectedEventTypes(filters);

  const { events } = useTeamEvents(teamId, filters, games);

  const insightPanel = <InsightPanel events={events} selectedEventTypes={selectedEventTypes} />;

  if (isNarrowViewport) {
    return hasEventInsights(selectedEventTypes) ? <EventInsightsCard>{insightPanel}</EventInsightsCard> : null;
  }

  return hasEventInsights(selectedEventTypes) ? insightPanel : <EventInsightsEmpty />;
};
